module.exports = __webpack_public_path__ + "img/terrorism2.d8b39749.svg";